import { useDecision } from '@optimizely/react-sdk'
import { UserAttributes, OptimizelyDecideOption } from '@optimizely/optimizely-sdk'

interface Options {
  autoUpdate?: boolean
  timeout?: number
  decideOptions?: OptimizelyDecideOption[]
}

interface Overrides {
  overrideUserId?: string
  overrideAttributes?: UserAttributes
}

interface FeatureFlagOptions {
  featureKey: string
  options?: Options
  overrides?: Overrides
}

interface FeatureFlag {
  isFeatureFlagReady: boolean
  isFeatureFlagEnabled: boolean
  variant: string | null
}

const useFeatureFlag = ({
  featureKey,
  options = { autoUpdate: false },
  overrides,
}: FeatureFlagOptions): FeatureFlag => {
  const [decision, isFeatureFlagReady] = useDecision(featureKey, options, overrides)

  const isFeatureFlagEnabled = decision.enabled

  const variant = decision.variationKey

  return { isFeatureFlagReady, isFeatureFlagEnabled, variant }
}

export default useFeatureFlag
